import type { ScreenModule } from "../../../app/screen-module";
import { ApprovalListPage } from "../ApprovalPages";

export default {
	id: "end-user.approvals",
	path: "/app/approvals",
	area: "end-user",
	navGroup: "確認する",
	label: "承認・差戻し",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: ApprovalListPage,
} satisfies ScreenModule;
